import { makeAutoObservable, runInAction } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { ContactsApi } from 'entities/Contacts'
import { type IParamsFiltersList } from 'entities/Broadcast/api/types'
import { ActivateWorkflowModalUi } from 'pages/workflows/ui/ActivateWorkflowModal/ui/ActivateWorkflowModalUi'

export type IParamsActivateWorkflowModalStore = {
  filters: IParamsFiltersList
  excludeFilters: IParamsFiltersList
  onPublish?: (params: { isEnrollExist: boolean }, withError?: boolean) => Promise<void>
  onCancel?: () => void
}

export class ActivateWorkflowModalStore {
  private _onPublish
  private _onCancel
  private _modalId = nanoid()
  private _contactsCount = 0
  private _loadingContactsCount = true
  private _isEnrollExist = false

  constructor(params: IParamsActivateWorkflowModalStore) {
    makeAutoObservable(this)

    this._onPublish = params.onPublish
    this._onCancel = params.onCancel
    this.openModal(params)
  }

  setIsEnrollExist = (value: boolean) => {
    this._isEnrollExist = value
  }

  openModal = async (params: IParamsActivateWorkflowModalStore) => {
    try {
      modalStore.addModal({
        id: this._modalId,
        title: 'Review',
        pureContent: true,
        width: 540,
        ModalContent: () => <ActivateWorkflowModalUi store={this} />,
        onClose: this.onClose,
      })

      if (params.filters) {
        const { data } = await ContactsApi.getContactsFiltersCount({
          filtersListGroups: params.filters,
          excludeFiltersListGroups: params.excludeFilters,
        })
        runInAction(() => {
          this._loadingContactsCount = false
          this._contactsCount = data.count
        })
      }
    } catch (e) {
      logger.error(e)
    }
  }

  onPublish = async () => {
    try {
      await this._onPublish?.({
        isEnrollExist: this._isEnrollExist,
      })
      this._onRemoveModal()
    } catch (e) {
      this._onRemoveModal()
      logger.error(e)
    }
  }

  private _onRemoveModal = () => {
    modalStore.removeModal(this._modalId)
  }

  onClose = () => {
    this._onCancel?.()
    this._onRemoveModal()
  }

  get isEnrollExist() {
    return this._isEnrollExist
  }

  get contactsCount() {
    return this._contactsCount
  }

  get loadingContactsCount() {
    return this._loadingContactsCount
  }
}
